import { mergeRefs } from '@calendly/ui/utils/merge-refs'
import { useMemo, useRef } from 'react'

/**
 * Anchor ref for a portaled dropdown trigger, optionally merged with a forwarded ref.
 *
 * @param {React.RefObject} [forwardedRef] - Ref from forwardRef when the trigger is forwarded
 * @returns {{ anchorRef: React.RefObject, containerRef: React.RefObject }}
 */
export const usePortaledMenuAnchor = (forwardedRef) => {
  const anchorRef = useRef(null)
  const containerRef = useMemo(
    () => (forwardedRef != null ? mergeRefs(anchorRef, forwardedRef) : anchorRef),
    [forwardedRef]
  )

  return { anchorRef, containerRef }
}
